import { getDetaileMoreProducts } from '@/utils';
import { useGlobal } from '@/utils/useGlobal';
import { LineSpace } from '@/components/ProductComponents';
import TextModule from '@/components/ProductDetailComponents/TextModule';
import TextWithImage from '@/components/ProductDetailComponents/TextWithImage';
import TextOnImage from '@/components/ProductDetailComponents/TextOnImage';
import MultiSellPointsThirdModule from '@/components/ProductDetailComponents/MultiSellPointsModule/Third';
import { EFACCharging, EFSCharging, EFCCharging } from '@/components/UI/svg/ProductStatic';
import { getImageLocal, getImageSpec } from '@/utils/locals';
import { createEFPic } from '@/utils/useEFPic';
import OtherList from '@/components/ProductCommon/OtherList';
import AppPointRiverBase from '@/components/AppPoint/RiverBasePC';
import { SHOW_APP_POINT_SITES } from '@/constants';

const { EFPic } = createEFPic('/media/river/pc/');

export default function IndexDynamic() {
    const { gloproductlist, useLang, useRouter, Link } = useGlobal();
    const { t } = useLang('riverportablepowerstation');
    const { locale } = useRouter();
    const imgSpec = getImageSpec(locale, ['au', 'uk', 'cn', 'de', 'fr', 'es', 'it', 'eu', 'za']);
    const appImgLocal = getImageLocal(locale, ['jp', 'de', 'fr', 'cn']);
    const data1 = {
        text: t('river.capacity'),
    };
    const style1 = {
        fontSize: '32px',
        lineHeight: '40px',
        textAlign: 'center',
        margin: '30px auto 0',
    };
    const data2 = {
        text: t('river.capacity_sub_title'),
    };
    const style2 = {
        type: 'ls',
        textAlign: 'center',
        margin: '10px auto 0',
    };
    const data3 = {
        text: t('river.capacity_desc'),
    };
    const style3 = {
        type: 'sl',
        textAlign: 'center',
        margin: '40px auto 0',
    };
    const data4 = {
        text: t('river.capacity_notice'),
    };
    const style4 = {
        type: 'ss',
        textAlign: 'center',
        margin: '32px auto 0',
        width: '924px',
    };

    const item1 = {
        title: t('river.battery_system'),
        synopsis: t('river.battery_system_sub_title'),
        desc: t('river.battery_system_desc'),
        bgImgs: ['bms-river.webp', 'bms-river.jpg'],
    };

    const item2 = {
        title: t('river.app_support'),
        synopsis: t('river.app_support_sub_title'),
        desc: t('river.app_support_desc'),
        bgImgs: [`app-support-river_${appImgLocal}.webp`, `app-support-river_${appImgLocal}.jpg`],
    };

    const items3 = {
        guide: { text: t('river.charging') },
        title: { type: 'ls', text: t('river.charging_desc') },
        desc: { text: '' },
        items: [
            {
                icon: <EFACCharging />,
                title: t('river.charging_title1'),
                des: t('river.charging_desc1'),
                directUrl: '/',
            },
            {
                icon: <EFSCharging />,
                title: t('river.charging_title2'),
                des: t('river.charging_desc2'),
                directUrl: '/',
            },
            {
                icon: <EFCCharging />,
                title: t('river.charging_title3'),
                des: t('river.charging_desc3'),
                directUrl: '/',
            },
        ],
    };

    const data5 = {
        img_url: ['x-boost-river.webp', 'x-boost-river.jpg'],
        title: t('river.AC_output'),
        synopsis: t('river.AC_output_sub_title'),
        noUseHtmlAttr: false,
        desc: t.rich('river.AC_output_desc', {
            line1: (text: string) => (
                <Link className="ef-link__page" href="/x-boost" newWin>
                    {text}
                </Link>
            ),
        }),
        arr: [
            { num: 600, eum: 'w', desc: t('river.AC_output_desc1') },
            { num: locale === 'cn' ? 1800 : 1200, eum: 'w', desc: t('river.AC_output_desc2') },
        ],
    };

    const data7 = {
        text: t('river.plus'),
    };
    const data8 = {
        text: t('river.plus_sub_title'),
    };
    const data9 = {
        text: t('river.plus_desc'),
    };

    const product: any = {
        us: ['product_ps_river_river_768', 'product_ps_delta_delta_2', 'product_ps_delta_delta_max'],
        za: ['product_ps_river_river_max', 'product_ps_river_river_pro_720', 'product_ps_delta_delta_pro'],
    };
    const otherProductData = getDetaileMoreProducts(gloproductlist, product[locale] || product.us);

    const web1Map = {
        us: ['RIVER_web_01.webp', 'RIVER_web_01.png'],
        au: ['RIVER_web_01_au.webp', 'RIVER_web_01_au.png'],
        uk: ['RIVER_web_01_uk.webp', 'RIVER_web_01_uk.png'],
        de: ['RIVER_web_01_eu.webp', 'RIVER_web_01_eu.png'],
        fr: ['RIVER_web_01_eu.webp', 'RIVER_web_01_eu.png'],
        eu: ['RIVER_web_01_eu.webp', 'RIVER_web_01_eu.png'],
        it: ['RIVER_web_01_eu.webp', 'RIVER_web_01_eu.png'],
        es: ['RIVER_web_01_eu.webp', 'RIVER_web_01_eu.png'],
        cn: ['RIVER_web_01_cn.webp', 'RIVER_web_01_cn.png'],
        za: ['RIVER_web_01_za.webp', 'RIVER_web_01_za.png'],
        sa: ['RIVER_web_01_uk.webp', 'RIVER_web_01_uk.png'],
        kr: ['RIVER_web_01_eu.webp', 'RIVER_web_01_eu.png'],
    };

    return (
        <>
            <LineSpace height={150} background="transparent" />
            <div className="section2">
                <div className="top">
                    <div className="tl box">
                        <EFPic
                            name={web1Map[locale as keyof typeof web1Map] || web1Map['us']}
                            alt={t('river.ytdd_section1_tit')}
                            aria-label={t('river.ytdd_section1_tit')}
                        />
                        <p className="tit">{t('river.ytdd_section1_tit')}</p>
                    </div>
                    <div className="tr box">
                        <div className="trt box">
                            <EFPic
                                name={['RIVER_web_04.webp', 'RIVER_web_04.png']}
                                alt={t('river.ytdd_section4_tit2')}
                                aria-label={t('river.ytdd_section4_tit2')}
                            />
                            <p className="tit">{t('river.ytdd_section4_tit2')}</p>
                        </div>
                        <div className="trb box">
                            <EFPic
                                name={['RIVER_web_05.webp', 'RIVER_web_05.png']}
                                alt={t('river.ytdd_section3_btm_tit3')}
                                aria-label={t('river.ytdd_section3_btm_tit3')}
                            />
                            <div className="tit">
                                {t('river.ytdd_section3_btm_tit1')} {t('river.ytdd_section3_btm_tit2')}
                                <p className="num">{t('river.ytdd_section3_btm_tit3')}</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="bottom">
                    <div className="bl box">
                        <EFPic name={['RIVER_web_02.webp', 'RIVER_web_02.png']} alt={t('river.ytdd_section2_tit')} aria-label={t('river.ytdd_section2_tit')} />
                        <p className="tit">{t('river.ytdd_section2_tit')}</p>
                        <p className="num">600W</p>
                    </div>
                    <div className="bm box">
                        <EFPic
                            name={['RIVER_web_03.webp', 'RIVER_web_03.png']}
                            alt={t('river.ytdd_section5_special')}
                            aria-label={t('river.ytdd_section5_special')}
                        />
                        <p className="tit">
                            <span className="txt">{t('river.ytdd_section5_tit2')}</span>
                            <span>{t('river.ytdd_section5_special')}</span>
                        </p>
                    </div>
                    <div className="br box">
                        <EFPic
                            name={['RIVER_web_06.webp', 'RIVER_web_06.png']}
                            alt={t('river.ytdd_section3_top_tit')}
                            aria-label={t('river.ytdd_section3_top_tit')}
                        />
                        <p className="tit">{t('river.ytdd_section3_top_tit')}</p>
                    </div>
                </div>
            </div>
            <LineSpace height={180} background="transparent" />
            <div className="textModule1">
                <TextModule data={data1} cssStyle={style1} />
            </div>
            <div className="textModule2">
                <TextModule data={data2} cssStyle={style2} />
            </div>
            <div className="textModule3">
                <TextModule
                    data={data3}
                    cssStyle={{
                        ...style3,
                        width: locale === 'cn' ? '540px' : '924px',
                    }}
                />
            </div>
            <TextModule data={data4} cssStyle={style4} />
            <LineSpace height={80} background="transparent" />
            <div className="banner-content">
                <EFPic name={['288-wh-capacity-river.webp', '288-wh-capacity-river.jpg']} className="fullImgs" alt={t('288Wh Capacity')} />
            </div>
            <LineSpace height={30} background="transparent" />
            <div style={{ display: 'flex', justifyContent: 'center' }} className="textWithImg1">
                <TextWithImage config={{ padding: '180px 0', position: 'right', isWebp: true, webpUrl: '/media/river/pc/' }} data={data5} />
            </div>
            <LineSpace height={90} background="transparent" />
            <MultiSellPointsThirdModule
                data={items3}
                cssStyle={{
                    textIconStyle: {
                        wrapperBackColor: '#f6f6f8',
                        wrapperPadding: locale === 'jp' ? '20px 40px' : '40px 50px',
                        wrapperHeight: (() => {
                            const mapHeight = {
                                de: '460px',
                                fr: '420px',
                                es: '440px',
                                jp: '420px',
                            };
                            type Asmapheight = keyof typeof mapHeight;
                            return mapHeight[locale as Asmapheight] || '400px';
                        })(),
                        wrapperBorderRadius: '20px',
                    },
                    titleStyle: {
                        width: locale === 'cn' ? '770px' : locale === 'jp' ? '730px' : '480px',
                    },
                }}
            />
            <LineSpace height={180} background="transparent" />
            <div className="textOnImg2">
                <TextOnImage data={item1} config={{ position: 'bottom', isWebp: true, webpUrl: '/media/river/pc/' }} />
            </div>
            <LineSpace height={110} background="transparent" />
            {!SHOW_APP_POINT_SITES.includes(locale) && (
                <div className="textOnImg3">
                    <TextOnImage data={item2} config={{ isWebp: true, webpUrl: '/media/river/pc/' }} />
                </div>
            )}
            {SHOW_APP_POINT_SITES.includes(locale) && <AppPointRiverBase />}
            <LineSpace height={120} background="transparent" />
            <section className="RIVER-Plus">
                <TextModule data={data7} cssStyle={style1} />
                <div className="textModule8">
                    <TextModule data={data8} cssStyle={style2} />
                </div>
                <div className="textModule9">
                    <TextModule data={data9} cssStyle={{ ...style3, ...{ margin: '40px auto 90px auto' } }} />
                </div>
                <div className="riverPlusImg">
                    <EFPic name={[`river-plus-360-wh_${imgSpec}.webp`, `river-plus-360-wh_${imgSpec}.jpg`]} alt={t('EcoFlow RIVER Plus')} />
                </div>
                <LineSpace height={270} background="transparent" />
            </section>
            <OtherList data={otherProductData} />
        </>
    );
}
